import { PricingPlan } from '@services/appsync/types';

export default {
  ADJUST_STORE_LINK:
    'https://app.adjust.com/i4ohvlx?fallback=https%3A%2F%2Fconcreit.com&redirect_android=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.concreit.fund_mobile_app%26hl%3Den_US%26gl%3DUS&redirect_ios=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fconcreit-real-estate-investing%2Fid1472440982',
  CURRENT_PRICING_PLAN: PricingPlan.FIVE_DOLLARS_UNDER_5K,
  DWOLLA_PRIVACY_POLICY: 'https://www.dwolla.com/legal/privacy',
  DWOLLA_TERMS_OF_SERVICE: 'https://www.dwolla.com/legal/tos',
  ESIGN: 'https://concreit.com/legal/esign',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAZKMoXSNlcFPxTCT3nVY5GsOBItH_OHTg',
  MIN_ACCOUNT_BALANCE_FEE_THRESHOLD: 5000,
  PRIVACY_POLICY: 'https://concreit.com/legal/privacy-policy',
  PROGRAM_AGREEMENT: 'https://www.concreit.com/legal/advisory-agreement/',
  STORE_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=com.concreit.fund_mobile_app&hl=en_US&gl=US',
  STORE_LINK_IOS: 'https://apps.apple.com/us/app/concreit-real-estate-investing/id1472440982',
  TERMS: 'https://concreit.com/legal/terms',
  US_COUNTRY_CODE: '+1',
};
